import { ActionList, Card, Avatar, Box, Button, Divider, InlineGrid, InlineStack, Modal, Popover, ResourceList, Text, TextField, BlockStack } from "@shopify/polaris";
import { EditIcon, DeleteIcon } from '@shopify/polaris-icons'
import { useState } from "react";
import { usePartnerUp } from "../providers/PartnerUpStoreProvider";
import EmojiPicker from "emoji-picker-react";
import { addDoc, collection, deleteDoc, doc, setDoc } from "firebase/firestore";

export default function ManageBuckets({ open, onClose }) {
  const { db, auth, setToast, leads, buckets, refetchBuckets } = usePartnerUp();
  const [changingIndex, setChangingIndex] = useState(false);
  const [localBucket, setLocalBucket] = useState({ name: 'New Bucket', emoji: '⚡' });
  const [emojiPickerOpen, setEmojiPickerOpen] = useState(false)
  const [deleteLoading, setDeleteLoading] = useState(false)

  const [saveLoading, setSaveLoading] = useState(false)
  const [deleteAreYouSure, setDeleteAreYouSure] = useState(null)

  async function saveBucket() {
    try {
      setSaveLoading(true)
      if (localBucket?.id) {
        await setDoc(doc(db, "usersV2", auth.currentUser?.uid, "buckets", localBucket.id), {
          name: localBucket?.name,
          emoji: localBucket?.emoji
        })
      } else {
        await addDoc(collection(db, "usersV2", auth.currentUser?.uid, "buckets"), {
          name: localBucket?.name,
          emoji: localBucket?.emoji
        })
      }
      await refetchBuckets()
      setChangingIndex(false)
      setToast({ content: 'Saved Tag' })
    } catch (e) {
      console.error(e)
      setToast({ content: 'Error saving. Please try again.', isError: true })
    } finally {
      setSaveLoading(false)
    }

  }

  async function deleteBucket(bucketID) {
    try {
      setDeleteLoading(bucketID)
      await deleteDoc(doc(db, "usersV2", auth?.currentUser?.uid, 'buckets', bucketID))
      await refetchBuckets()
      setToast({ content: 'Deleted Tag' })
    } catch (e) {
      setToast({ content: 'Error deleting. Please try again.', isError: true })
      console.error(e)
    } finally {
      setDeleteLoading(false)
    }
  }

  console.log('buickets are', buckets)

  return (
    <Modal title="Creator Tags" open={open} onClose={onClose} secondaryActions={[
      {
        content: 'Done',
        onAction: onClose
      }
    ]}>
      <Box background="bg-subdued">
        <Modal.Section>
          <BlockStack gap="300">
            {
              emojiPickerOpen ? (
                <EmojiPicker onEmojiClick={({ emoji }) => {
                  setLocalBucket({ ...localBucket, emoji })
                  setEmojiPickerOpen(false)
                }} />
              ) : null
            }
            <InlineGrid gap="200" columns="1">
              {
                buckets?.length ? buckets.map(bucket => {
                  const bucketLeads = leads?.filter(l => l?.buckets?.includes(bucket.id))
                  return (
                    <Card key={bucket.name}>
                      {
                        changingIndex === bucket.name ? (
                          <BlockStack gap="200">
                            <InlineStack blockAlign="end" gap="100">
                              <Button size="large" onClick={() => setEmojiPickerOpen(true)}>{localBucket?.emoji}</Button>
                              <TextField value={localBucket?.name} onChange={(value) => setLocalBucket({ ...localBucket, name: value })} />
                            </InlineStack>
                            <InlineStack gap="200">
                              <Button size="slim" loading={saveLoading} onClick={saveBucket}>Save</Button>
                              <Button size="slim" disabled={saveLoading} onClick={() => setChangingIndex(null)}>Cancel</Button>
                            </InlineStack>
                          </BlockStack>
                        ) : (
                          <InlineStack gap="200" align="space-between" blockAlign="start">
                            <InlineStack align="start" blockAlign="center" gap="5">
                              <Text variant="headingXl">{bucket.emoji}</Text>
                              <BlockStack inlineAlign="start" gap="100">
                                <Text variant="headingMd">{bucket.name}</Text>
                                <Text variant="bodyMd">{bucketLeads?.length || 0} Creators</Text>
                                <InlineStack gap="300">
                                  <InlineStack>
                                  </InlineStack>
                                </InlineStack>
                              </BlockStack>
                            </InlineStack>
                            <InlineStack align="end" gap="100">
                              <Button icon={EditIcon} size="slim" onClick={() => {
                                setChangingIndex(bucket.name)
                                setLocalBucket({
                                  id: bucket.id,
                                  name: bucket.name,
                                  emoji: bucket.emoji
                                })
                              }}></Button>
                              <Popover
                                active={deleteAreYouSure === bucket.id}
                                onClose={() => setDeleteAreYouSure(null)}
                                activator={
                                  <Button loading={deleteLoading === bucket.id} size="slim" onClick={() => setDeleteAreYouSure(bucket.id)} icon={DeleteIcon} />
                                }
                              >
                                <ActionList items={[
                                  { content: 'Delete', destructive: true, onAction: () => deleteBucket(bucket.id) }
                                ]} />
                              </Popover>
                            </InlineStack>
                          </InlineStack>
                        )
                      }
                    </Card>
                  )
                }) : changingIndex && changingIndex?.includes('New Tag') ? null : 'None Yet'
              }
              {
                changingIndex && changingIndex?.includes('New Tag') && localBucket?.isNew ? (
                  <Card>
                    <BlockStack gap="200">
                      <InlineStack blockAlign="end" gap="100">
                        <Button size="large" onClick={() => setEmojiPickerOpen(true)}>{localBucket?.emoji}</Button>
                        <TextField value={localBucket?.name} onChange={(value) => setLocalBucket({ ...localBucket, name: value })} />
                      </InlineStack>
                      <InlineStack gap="100">
                        <Button size="slim" onClick={saveBucket} loading={saveLoading}>Save</Button>
                        <Button size="slim" onClick={() => setChangingIndex(null)} disabled={saveLoading}>Cancel</Button>
                      </InlineStack>
                    </BlockStack>
                  </Card>
                ) : null
              }
            </InlineGrid>
            <InlineStack align="end">
              <Button size="slim" onClick={() => {
                const bucketName = `New Tag #${(buckets?.length || 0) + 1}`
                setChangingIndex(bucketName)
                setLocalBucket({ name: bucketName, emoji: '⚡', isNew: true })
              }}>New Tag</Button>
            </InlineStack>
          </BlockStack>
        </Modal.Section>
      </Box>
    </Modal>
  )
}
